import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const links = [
  { label: "Comment ça marche", href: "/#comment-ca-marche" },
  { label: "Fonctionnalités", href: "/#fonctionnalites" },
  { label: "Rendez-vous", href: "/#rdv" },
  { label: "Cas d'usage", href: "/#temoignages" },
  { label: "Tarifs", href: "/#tarifs" },
  { label: "FAQ", href: "/#faq" },
];

export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 border-b transition-colors ${
        scrolled
          ? "border-line bg-cream/90 backdrop-blur-md"
          : "border-transparent bg-cream"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-8">
        <a href="/">
          <Logo />
        </a>

        <nav className="hidden items-center gap-8 lg:flex">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm font-medium text-ink-soft transition-colors hover:text-ink"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-4 lg:flex">
          <Link
            to="/commercant"
            className="text-sm font-semibold text-ink-soft transition-colors hover:text-ink"
          >
            Connexion
          </Link>
          <a
            href="/#demo"
            className="rounded-full bg-ink px-5 py-2.5 text-sm font-semibold text-white transition-transform hover:scale-[1.03]"
          >
            Réserver une démo →
          </a>
        </div>

        <button
          className="lg:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="Ouvrir le menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-line bg-cream px-6 py-4 lg:hidden">
          <nav className="flex flex-col gap-4">
            {links.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="text-sm font-medium text-ink-soft"
              >
                {link.label}
              </a>
            ))}
            <Link
              to="/commercant"
              onClick={() => setOpen(false)}
              className="text-sm font-medium text-ink-soft"
            >
              Connexion
            </Link>
            <a
              href="/#demo"
              onClick={() => setOpen(false)}
              className="rounded-full bg-ink px-5 py-2.5 text-center text-sm font-semibold text-white"
            >
              Réserver une démo →
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
